import React, { useState, useMemo } from "react"
import { withStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import MuiDialogActions from "@material-ui/core/DialogActions"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/styles"
import { AddCircle, RemoveCircle } from "@material-ui/icons"
import { FormControl, Input, InputAdornment } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    formInputWrapper: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "250px",
        overflow: "scroll",
        overflowX: "hidden",
    },

    controlsWrapper: {
        display: "flex",
        "& :nth-child(1)": {
            flex: 1,
        },
    },
    formFooter: {
        display: "flex",
        justifyContent: "flex-end",
    },
    textFieldWrapper: {
        margin: "12px 12px",
        display: "flex",
        alignItems: "center",
    },
}))

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1.5),
        top: theme.spacing(1.5),
        color: "#ffffff",
        backgroundColor: theme.palette.primary.main,
        width: "28px",
        height: "28px",
        "&:hover": {
            backgroundColor: theme.palette.primary.secondary,
        },
    },
    diaglogWrapper: {
        width: "280px",
    },
})

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions)

let inputUniqueIdCounter = 1
function inputUniqueId() {
    inputUniqueIdCounter += 1
    return inputUniqueIdCounter
}

const AddSingleInput = (props) => {
    const { id, setFormValues, formValues } = props
    const [singleInputValue, setSingleInputValue] = useState("")

    const handleFormChange = (event) => {
        const inputValue = event.target.value
        setSingleInputValue(inputValue)
        setFormValues((prev) => {
            return prev.map((prevItem) => {
                if (prevItem.id === id) {
                    return {
                        id: prevItem.id,
                        name: inputValue,
                    }
                }
                return prevItem
            })
        })
    }

    const handleRemoveDepartment = () => {
        setFormValues((previousValues) => {
            return previousValues.filter((prevItem) => prevItem.id !== id)
        })
    }

    return (
        <FormControl variant="outlined">
            <Input
                placeholder="Department Name"
                onChange={(event) => handleFormChange(event)}
                value={singleInputValue}
                id="standard-adornment-password"
                type="text"
                endAdornment={
                    formValues.length > 1 && (
                        <InputAdornment position="end">
                            <IconButton aria-label="remove current department" onClick={() => handleRemoveDepartment()}>
                                <RemoveCircle />
                            </IconButton>
                        </InputAdornment>
                    )
                }
            />
        </FormControl>
    )
}

const defaultFormValues = [{ id: 1, name: "" }]

const AddSingle = (props) => {
    const classes = useStyles(props)
    const { handleModalClose, open, addActions } = props
    const [isFormInvalid, setIsFormInvalid] = useState(false)
    const [formValues, setFormValues] = useState(defaultFormValues)

    const handleAdd = () => {
        // Check all formValues are not empty
        let isValid = true
        formValues.forEach((formValue) => {
            if (formValue.name === "") {
                setIsFormInvalid(true)
                isValid = false
            }
        })

        if (isValid) {
            addActions(formValues)
            handleModalClose()
            setFormValues(defaultFormValues)
        }
    }

    const descriptions = useMemo(
        () => (
            <Typography>
                Add below the department options you wish to be included in the assessment as a dropdown selection for participants
            </Typography>
        ),
        []
    )

    const handleAddMore = () => {
        setFormValues((prev) => [...prev, { id: inputUniqueId(), name: "" }])
    }

    return (
        <div>
            <Dialog
                onClose={() => {
                    handleModalClose()
                    setFormValues(defaultFormValues)
                }}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle
                    id="customized-dialog-title"
                    onClose={() => {
                        handleModalClose()
                        setFormValues(defaultFormValues)
                    }}
                >
                    Add New Department
                </DialogTitle>
                <DialogContent>
                    <Box>{descriptions}</Box>
                    <Box marginTop="16px">{isFormInvalid && <Typography color="primary">Please fill all the fields</Typography>}</Box>
                    <Box className={classes.formInputWrapper}>
                        <Box className={classes.controlsWrapper}>
                            <Box>
                                {formValues.map((form) => (
                                    <Box key={form.id} className={classes.textFieldWrapper}>
                                        <AddSingleInput id={form.id} setFormValues={setFormValues} formValues={formValues} />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton aria-label="add another department" onClick={handleAddMore}>
                            <AddCircle color="primary" />
                        </IconButton>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" autoFocus onClick={handleAdd} color="primary">
                        Add Department
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default AddSingle
